import React from 'react'
import { useTimeTravel } from '@fs/zion-rootstech'
import { Badge } from './Badge'
import { hour } from '../config'
import { MonoText } from './type'

export default function Classroom({ classroom, date, sessionLocation, inline = false }) {
  const { getNow } = useTimeTravel()
  const isInPerson = sessionLocation?.includes('In Person')
  const currentDate = new Date(getNow())
  const hourPastStartTime = date + 1 * hour

  if (!classroom || !date || currentDate > hourPastStartTime || !isInPerson) return null

  if (inline) return <span data-testid={`item-${classroom}`}>{classroom}</span>

  return (
    <Badge
      data-testid={`item-${classroom}`}
      flavor="flavorless"
      keyline="left"
      label={<MonoText>{classroom} </MonoText>}
    />
  )
}
